const CARDS_LIST = [
  {
    "name": "Дурак",
    "name_en": "The Fool",
    "number": "0",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m00.jpg"
  },
  {
    "name": "Маг",
    "name_en": "The Magician",
    "number": "1",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m01.jpg"
  },
  {
    "name": "Верховная Жрица",
    "name_en": "The High Priestess",
    "number": "2",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m02.jpg"
  },
  {
    "name": "Императрица",
    "name_en": "The Empress",
    "number": "3",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m03.jpg"
  },
  {
    "name": "Император",
    "name_en": "The Emperor",
    "number": "4",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m04.jpg"
  },
  {
    "name": "Иерофант",
    "name_en": "The Hierophant",
    "number": "5",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m05.jpg"
  },
  {
    "name": "Влюбленные",
    "name_en": "The Lovers",
    "number": "6",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m06.jpg"
  },
  {
    "name": "Колесница",
    "name_en": "The Chariot",
    "number": "7",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m07.jpg"
  },
  {
    "name": "Сила",
    "name_en": "Strength",
    "number": "8",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m08.jpg"
  },
  {
    "name": "Отшельник",
    "name_en": "The Hermit",
    "number": "9",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m09.jpg"
  },
  {
    "name": "Колесо Фортуны",
    "name_en": "Wheel of Fortune",
    "number": "10",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m10.jpg"
  },
  {
    "name": "Справедливость",
    "name_en": "Justice",
    "number": "11",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m11.jpg"
  },
  {
    "name": "Повешенный",
    "name_en": "The Hanged Man",
    "number": "12",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m12.jpg"
  },
  {
    "name": "Смерть",
    "name_en": "Death",
    "number": "13",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m13.jpg"
  },
  {
    "name": "Умеренность",
    "name_en": "Temperance",
    "number": "14",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m14.jpg"
  },
  {
    "name": "Дьявол",
    "name_en": "The Devil",
    "number": "15",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m15.jpg"
  },
  {
    "name": "Башня",
    "name_en": "The Tower",
    "number": "16",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m16.jpg"
  },
  {
    "name": "Звезда",
    "name_en": "The Star",
    "number": "17",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m17.jpg"
  },
  {
    "name": "Луна",
    "name_en": "The Moon",
    "number": "18",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m18.jpg"
  },
  {
    "name": "Солнце",
    "name_en": "The Sun",
    "number": "19",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m19.jpg"
  },
  {
    "name": "Суд",
    "name_en": "Judgement",
    "number": "20",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m20.jpg"
  },
  {
    "name": "Мир",
    "name_en": "The World",
    "number": "21",
    "arcana": "Major Arcana",
    "suit": null,
    "img": "m21.jpg"
  },
  {
    "name": "Туз Чаш",
    "name_en": "Ace of Cups",
    "number": "1",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c01.jpg"
  },
  {
    "name": "Двойка Чаш",
    "name_en": "Two of Cups",
    "number": "2",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c02.jpg"
  },
  {
    "name": "Тройка Чаш",
    "name_en": "Three of Cups",
    "number": "3",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c03.jpg"
  },
  {
    "name": "Четверка Чаш",
    "name_en": "Four of Cups",
    "number": "4",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c04.jpg"
  },
  {
    "name": "Пятерка Чаш",
    "name_en": "Five of Cups",
    "number": "5",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c05.jpg"
  },
  {
    "name": "Шестерка Чаш",
    "name_en": "Six of Cups",
    "number": "6",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c06.jpg"
  },
  {
    "name": "Семерка Чаш",
    "name_en": "Seven of Cups",
    "number": "7",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c07.jpg"
  },
  {
    "name": "Восьмерка Чаш",
    "name_en": "Eight of Cups",
    "number": "8",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c08.jpg"
  },
  {
    "name": "Девятка Чаш",
    "name_en": "Nine of Cups",
    "number": "9",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c09.jpg"
  },
  {
    "name": "Десятка Чаш",
    "name_en": "Ten of Cups",
    "number": "10",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c10.jpg"
  },
  {
    "name": "Паж Чаш",
    "name_en": "Page of Cups",
    "number": "11",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c11.jpg"
  },
  {
    "name": "Рыцарь Чаш",
    "name_en": "Knight of Cups",
    "number": "12",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c12.jpg"
  },
  {
    "name": "Королева Чаш",
    "name_en": "Queen of Cups",
    "number": "13",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c13.jpg"
  },
  {
    "name": "Король Чаш",
    "name_en": "King of Cups",
    "number": "14",
    "arcana": "Minor Arcana",
    "suit": "Cups",
    "img": "c14.jpg"
  },
  {
    "name": "Туз Мечей",
    "name_en": "Ace of Swords",
    "number": "1",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s01.jpg"
  },
  {
    "name": "Двойка Мечей",
    "name_en": "Two of Swords",
    "number": "2",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s02.jpg"
  },
  {
    "name": "Тройка Мечей",
    "name_en": "Three of Swords",
    "number": "3",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s03.jpg"
  },
  {
    "name": "Четверка Мечей",
    "name_en": "Four of Swords",
    "number": "4",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s04.jpg"
  },
  {
    "name": "Пятерка Мечей",
    "name_en": "Five of Swords",
    "number": "5",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s05.jpg"
  },
  {
    "name": "Шестерка Мечей",
    "name_en": "Six of Swords",
    "number": "6",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s06.jpg"
  },
  {
    "name": "Семерка Мечей",
    "name_en": "Seven of Swords",
    "number": "7",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s07.jpg"
  },
  {
    "name": "Восьмерка Мечей",
    "name_en": "Eight of Swords",
    "number": "8",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s08.jpg"
  },
  {
    "name": "Девятка Мечей",
    "name_en": "Nine of Swords",
    "number": "9",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s09.jpg"
  },
  {
    "name": "Десятка Мечей",
    "name_en": "Ten of Swords",
    "number": "10",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s10.jpg"
  },
  {
    "name": "Паж Мечей",
    "name_en": "Page of Swords",
    "number": "11",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s11.jpg"
  },
  {
    "name": "Рыцарь Мечей",
    "name_en": "Knight of Swords",
    "number": "12",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s12.jpg"
  },
  {
    "name": "Королева Мечей",
    "name_en": "Queen of Swords",
    "number": "13",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s13.jpg"
  },
  {
    "name": "Король Мечей",
    "name_en": "King of Swords",
    "number": "14",
    "arcana": "Minor Arcana",
    "suit": "Swords",
    "img": "s14.jpg"
  },
  {
    "name": "Туз Жезлов",
    "name_en": "Ace of Wands",
    "number": "1",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w01.jpg"
  },
  {
    "name": "Двойка Жезлов",
    "name_en": "Two of Wands",
    "number": "2",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w02.jpg"
  },
  {
    "name": "Тройка Жезлов",
    "name_en": "Three of Wands",
    "number": "3",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w03.jpg"
  },
  {
    "name": "Четверка Жезлов",
    "name_en": "Four of Wands",
    "number": "4",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w04.jpg"
  },
  {
    "name": "Пятерка Жезлов",
    "name_en": "Five of Wands",
    "number": "5",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w05.jpg"
  },
  {
    "name": "Шестерка Жезлов",
    "name_en": "Six of Wands",
    "number": "6",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w06.jpg"
  },
  {
    "name": "Семерка Жезлов",
    "name_en": "Seven of Wands",
    "number": "7",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w07.jpg"
  },
  {
    "name": "Восьмерка Жезлов",
    "name_en": "Eight of Wands",
    "number": "8",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w08.jpg"
  },
  {
    "name": "Девятка Жезлов",
    "name_en": "Nine of Wands",
    "number": "9",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w09.jpg"
  },
  {
    "name": "Десятка Жезлов",
    "name_en": "Ten of Wands",
    "number": "10",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w10.jpg"
  },
  {
    "name": "Паж Жезлов",
    "name_en": "Page of Wands",
    "number": "11",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w11.jpg"
  },
  {
    "name": "Рыцарь Жезлов",
    "name_en": "Knight of Wands",
    "number": "12",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w12.jpg"
  },
  {
    "name": "Королева Жезлов",
    "name_en": "Queen of Wands",
    "number": "13",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w13.jpg"
  },
  {
    "name": "Король Жезлов",
    "name_en": "King of Wands",
    "number": "14",
    "arcana": "Minor Arcana",
    "suit": "Wands",
    "img": "w14.jpg"
  },
  {
    "name": "Туз Пентаклей",
    "name_en": "Ace of Pentacles",
    "number": "1",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p01.jpg"
  },
  {
    "name": "Двойка Пентаклей",
    "name_en": "Two of Pentacles",
    "number": "2",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p02.jpg"
  },
  {
    "name": "Тройка Пентаклей",
    "name_en": "Three of Pentacles",
    "number": "3",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p03.jpg"
  },
  {
    "name": "Четверка Пентаклей",
    "name_en": "Four of Pentacles",
    "number": "4",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p04.jpg"
  },
  {
    "name": "Пятерка Пентаклей",
    "name_en": "Five of Pentacles",
    "number": "5",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p05.jpg"
  },
  {
    "name": "Шестерка Пентаклей",
    "name_en": "Six of Pentacles",
    "number": "6",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p06.jpg"
  },
  {
    "name": "Семерка Пентаклей",
    "name_en": "Seven of Pentacles",
    "number": "7",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p07.jpg"
  },
  {
    "name": "Восьмерка Пентаклей",
    "name_en": "Eight of Pentacles",
    "number": "8",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p08.jpg"
  },
  {
    "name": "Девятка Пентаклей",
    "name_en": "Nine of Pentacles",
    "number": "9",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p09.jpg"
  },
  {
    "name": "Десятка Пентаклей",
    "name_en": "Ten of Pentacles",
    "number": "10",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p10.jpg"
  },
  {
    "name": "Паж Пентаклей",
    "name_en": "Page of Pentacles",
    "number": "11",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p11.jpg"
  },
  {
    "name": "Рыцарь Пентаклей",
    "name_en": "Knight of Pentacles",
    "number": "12",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p12.jpg"
  },
  {
    "name": "Королева Пентаклей",
    "name_en": "Queen of Pentacles",
    "number": "13",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p13.jpg"
  },
  {
    "name": "Король Пентаклей",
    "name_en": "King of Pentacles",
    "number": "14",
    "arcana": "Minor Arcana",
    "suit": "Pentacles",
    "img": "p14.jpg"
  }
]

export default CARDS_LIST;
